// extracted by mini-css-extract-plugin
module.exports = {"titles":"HeroBannerPromoFamily_titles__qgrf_","titlesWrapper":"HeroBannerPromoFamily_titlesWrapper___70aW"};